module.exports = __webpack_public_path__ + "static/img/img1.c4b9e888.png";